<template>
    <section class="confirm">
        <div class="box">
            <div class="b-1">
                <img :src="logo_url" alt="logo">
            </div>
            <div class="b-2">
                <template>
                    <v-col>
                        <h2>Alterar senha de acesso</h2>
                        <p style="color: #595959"><i class="fas fa-envelope-open-text"></i> {{email}}</p>
                    </v-col>
                    <v-form ref="form">
                        <v-col>
                            <v-text-field
                                    solo
                                    type="password"
                                    class="input"
                                    v-model="password"
                                    :rules="rules.password"
                                    label="Nova senha">
                            </v-text-field>
                            <v-text-field
                                    solo
                                    type="password"
                                    class="input"
                                    v-model="confirm_password"
                                    :rules="rules.confirm_password"
                                    label="Confirmar nova senha">
                            </v-text-field>
                            <v-alert type="error" style="width: 300px" color="#e72c1f" v-if="error !== null">
                                {{error}}
                            </v-alert>
                            <v-btn color="#000" :loading="loading"
                                   :disabled="loading"
                                   @click.prevent="updatePassword()"
                                   class="btn-blue">
                                Atualizar Senha
                            </v-btn>
<!--                            <button class="btn-red d-block mt-2" @click.prevent="goTo('home')">-->
<!--                                Cancelar-->
<!--                            </button>-->
                        </v-col>
                    </v-form>
                </template>
            </div>
        </div>
        <v-snackbar
                v-model="message_success"
                :color="'success'"
                :multi-line="true"
                :right="true"
                :timeout="2000"
                :top="true"
                class="snackbar-success"
        >
            <span><i class="fas fa-check mr-2"></i> Senha atualizada com sucesso!</span>
        </v-snackbar>
        <v-dialog class="confirmEmail text-center mb-5" v-model="modal_download_app" width="350px">
            <v-card class="text-center" style="background: #003A73 !important;">
                <v-card-title>
                </v-card-title>
                <v-card-text>
                    <i class="fas fa-mobile-alt mb-2" style="color: #ffffff; font-size: 100px;"></i>
                    <div class="text-center">
                        <h2 style="font-size: 24px;color: #ffffff;font-family: Roboto-Black;margin: 0;">Acesse Nosso Aplicativo</h2>
                        <p class="my2">Disponível para Android e IOS</p>
                    </div>
                    <div>
                        <a class="d-block" v-if="android !== null" :href="android"><img class="m-2" src="@/assets/imgs/img-google-play.png"></a>
                        <a class="d-block" v-if="ios !== null" :href="ios"><img class="m-2" src="@/assets/imgs/img-apple-store.png"></a>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <div class="col-12">
                        <v-btn class="btn-white text-center" text @click="goTo('home')">OK</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
    export default {
        name: "RememberPassword",
        data:function () {
            return{
                android:null,
                ios:null,
                modal_download_app:false,
                loading:false,
                message_success:false,
                email:'',
                token:'',
                password:'',
                confirm_password:'',
                user:null,
                error:null,
                rules: {
                    password:[
                        value => (value || '').length > 0 || 'O campo nova senha é obrigatório',
                        value => (value || '').length >= 6 || 'A nova senha deve conter pelo menos 6 caracteres',
                    ],
                    confirm_password:[
                        value => (value || '').length > 0 || 'O campo confirmar nova senha é obrigatório',
                        value => (value === this.password) || 'O campo de confirmação de senha esta diferente',
                    ],
                }
            }
        },
        mounted(){
            this.email = this.$route.query.email;
            this.token = this.$route.query.token;
            axios.get('/api/webdriver/landpage',{params:{tags:'download_app_android'}}).then(res => {
                this.android = res.data.data[0].content;
                axios.get('/api/webdriver/landpage',{params:{tags:'download_app_ios'}}).then(res => {
                    this.ios = res.data.data[0].content;
                })
            });
        },
        methods:{
            updatePassword:function () {
                if(this.$refs.form.validate() !== false){
                    this.loading = true;
                    this.error = null;
                    var obj = {
                        email:this.email,
                        token:this.token,
                        password:this.password,
                        password_confirmation: this.confirm_password
                    };
                    axios.post('/password/reset',obj).then(res => {
                        this.message_success = true;
                        var vm = this;
                        setTimeout(function(){
                            vm.modal_download_app = true;
                        }, 1000);
                    }).catch(error => {
                        this.error =
                            Object.entries(error.response.data)[0][1].message
                            || Object.entries(error.response.data.error.errors)[0][1][0]
                            || 'Ocorreu um erro. Tente novamente.';
                    }).finally(r => {
                        this.loading = false;
                    })
                }
            },
            goTo:function (route) {
                this.$router.push({
                    name:route
                });
                location.reload();
            }
        },
        computed: {
            logo_url: function () {
                return require('@/assets/imgs/logos/' + process.env.VUE_APP_HIGH_CONTRAST_LOGO_NAME);
            }
        }
    }
</script>

<style scoped>
    h5{
        font-family: Roboto-Black !important;
        font-size: 24px !important;
        color: #58595B !important;
        text-align: center;
    }
    .input{
        width: 300px;
    }
    .confirm{
        width: 100%;
        height: 100vh;
        background-size: cover;
        background-image: url("../../assets/imgs/teste02.png");
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .box{
        width: 80%;
        height: 200px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .b-1{
        padding: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .b-2{
        text-align: left;
        width: 50%;
        padding: 0 0 0 15px;
    }
    h2{
        color: #595959;
        font-size: 24px;
        font-family: Roboto-Black;
        color: #595959;
        width: 400px;
    }
    p{
        font-family: Roboto-Light;
        font-size: 14px;
        width: 400px;
    }
    p i{
        color: #595959;
    }
    .btn-blue{
        text-transform: capitalize !important;
        background: #000 !important;
        color: #ffffff !important;
        font-family: Roboto-Black !important;
        height: 43px !important;
        border-radius: 4px !important;
        padding: 8px 15px !important;
        border: 3px solid #000 !important;
    }
    .btn-blue:hover{
        background: transparent !important;
        color: #000 !important;
    }
    .btn-red{
        background: transparent;
        font-family: Roboto-Black;
        width: 114px;
        height: 43px;
        border-radius: 4px;
        padding: 8px 15px;
        border: 3px solid #000;
        color: #000;
    }
    .btn-red:hover{
        background: #000;
        color: #ffffff;
    }

    .btn-red,.btn-blue{
        width: 300px;
    }

    @media only screen and (max-width: 500px) {
        .confirm{
            height: 100vh;
            text-align: center;
        }
        .box{
            display: block;
            width: 100%;
            height: auto;
            text-align: center;
        }

        .b-1{
            padding: 0;
            display: block;
            width: 100%;
        }

        .b-2{
            padding: 15px;
        }

        .b-1 img{
            margin: 0 auto;
        }

        h2,p{
            text-align: center;
        }


        h2,p,.b-2,.btn-blue,.btn-red{
            width: 100%;
        }

        .btn-red,.btn-blue{
            width: 100%;
        }

    }

    .btn-white{
        text-transform: capitalize !important;
        background: #ffffff !important;
        color: #000 !important;
        font-family: Roboto-Black !important;
        width: 120px;
        height: 43px !important;
        border-radius: 4px !important;
        padding: 8px 15px !important;
        border: 3px solid #000 !important;
    }
    .btn-white:hover{
        background: transparent !important;
        color: #ffffff !important;
        border: 3px solid #ffffff !important;
    }

    p{
        font-size: 14px;
        color: #ffffff;
        font-family: Roboto-Regular;
        margin: 0;
    }
</style>
